import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { BsSearch } from "react-icons/bs";
import { MdModeEdit, MdDelete, MdRefresh } from "react-icons/md";
import Button from "Button/Button";
import colors from "styles/colors.module.scss";
import "./TableToolbar.scss";
import { DateTimePicker } from "@material-ui/pickers";
import { IoCalendarOutline } from "react-icons/io5";
import moment from "moment";
import { TableTitle } from "constants/UserConstants";
import { InputAdornment } from "@material-ui/core";
import Select from "react-select";

function TableToolbar(props) {
  const {
    searchValue,
    onSearchTextChange,
    isEditEnabled,
    isDeleteEnabled,
    title,
    onDateChage,
    startDate,
    endDate,
    onRefreshClick,
    onRecentData,
    filterButtonText,
    statusDropDownList,
    selectedStatus,
    onStatusChange,
    agentId,
    onAgentIdSearch,
    tableDataCount
  } = props;
  const [searchText, setSearchText] = useState("");
  const [agentSearch, setAgentSearch] = useState("");

  useEffect(() => {
    setSearchText(searchValue);
    setAgentSearch(agentId);

  }, [searchValue, agentId]);

  const onSearchInputChange = (e) => {
    const newSearchText = e.target.value;
    setSearchText(newSearchText);
    onSearchTextChange(newSearchText);
  };
  const onAgentSearch = (e) => {
    const newSearchText = e.target.value;
    setAgentSearch(newSearchText);
    onAgentIdSearch(newSearchText);
  };

  const getDropdownStyles = () => {
    const customStyles = {
      container: (provided) => ({
        ...provided,
        width: "200px",
      }),
      control: (provided, { isDisabled }) => ({
        ...provided,
        width: "200px",
        minWidth: 120,
        height: 34,
        minHeight: 34,
        font: "normal normal bold 14px/19px Roboto",
        background: "white",
        paddingLeft: "0px",
        opacity: isDisabled ? 0.5 : 1,
        boxShadow: "0px 3px 6px #00000029",
        border: 0,
      }),
      option: (provided) => ({
        ...provided,
        background: "#fff",
        color: "#000",
        width: "200px",
        minWidth: 120,
        font: "Roboto",
        border: "none",
      }),
      dropdownIndicator: (provided, state) => ({
        ...provided,
        width: 28,
        paddingTop: 0,
        paddingBottom: 0,
        color: "#3c3c3f",
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      }),
      multiValue: (provided) => ({
        ...provided,
        fontFamily: "Roboto",
        color: "#96969B",
      }),
      multiValueRemove: (provided) => ({
        ...provided,
        color: "#96969B",
        "&:hover": {
          backgroundColor: "#3A8AFA",
          color: "#fff",
        },
      }),
      menu: (provided) => ({
        ...provided,
      }),
      placeholder: (provided) => ({
        ...provided,
        fontWeight: "normal",
      }),
    };
    return customStyles;
  };

  const isDateFilter = onDateChage ? "Filter" : "";
  return (
    <div className="table-toolbar">
      <div className="header-with-manage">
        {title && <h6 className="table-title">{title}</h6>}
        <div className="search-add-section">
          <div className="filter-container ">


            <div className={`search-input-with-icon ${isDateFilter} filter-box`}>
              <BsSearch className="search-icon" size="1em" />
              <input
                className="search-input"
                type="text"
                value={searchText}
                onChange={onSearchInputChange}
                placeholder="Search by any field"
              />
            </div>


            <div className="date-filter-container filter-box">
              <label>Filter</label>
              <div className="child-Filter">
                <DateTimePicker
                  variant="inline"
                  format="DD/MM/YYYY HH:mm a"
                  value={moment(startDate).format()}
                  maxDate={moment(endDate).format()}
                  onChange={(e) => onDateChage({
                    startDate: e._d
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IoCalendarOutline className="calender-icon" size="1.1em" />
                      </InputAdornment>
                    ),
                  }}
                />
                <label>To</label>
                <DateTimePicker
                  variant="inline"
                  format="DD/MM/YYYY HH:mm a"
                  value={moment(endDate).format()}
                  minDate={moment(startDate).format()}
                  openTo={"date"}
                  onChange={(e) => onDateChage({
                    endDate: e._d
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IoCalendarOutline className="calender-icon" size="1.1em" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="status-filter-container filter-box">
              <label>Status:</label>
              <Select
                onChange={onStatusChange}
                value={selectedStatus}
                options={statusDropDownList}
                placeholder="Select Channels"
                styles={getDropdownStyles()}
              />
            </div>

            <div className="agent-search-filter filter-box">
              <div className={`search-input-with-icon `}>
                <BsSearch className="search-icon" size="1em" />
                <input
                  className="search-input"
                  type="text"
                  value={agentSearch}
                  onChange={onAgentSearch}
                  placeholder="Search with agent name"
                />
              </div>
              <Button
                className="get-recent-opty"
                onClick={onRecentData}
                label={filterButtonText}
              />
            </div>


          </div>
          <div className="refresh-icon-container" onClick={onRefreshClick}>
            <MdRefresh className="refresh-icon" />
          </div>
        </div>
      </div>
      <div className={`edit-remove-section `}>
        {
          tableDataCount ?
            <div className="table-count">
              <span className="count-text">Count:</span>
              <span className="count-number">{tableDataCount}</span>
            </div>
            :
            null
        }
      </div>

    </div>
  );
}

TableToolbar.propTypes = {
  searchValue: PropTypes.string,
  onSearchTextChange: PropTypes.func.isRequired,
  onAddButtonClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  isEditEnabled: PropTypes.bool,
  isDeleteEnabled: PropTypes.bool,
  title: PropTypes.string,
  onDateChage: PropTypes.func,
  onRefreshClick: PropTypes.func,
};

TableToolbar.defaultProps = {
  searchValue: "",
  isEditEnabled: false,
  isDeleteEnabled: false,
  title: "",
};

export default TableToolbar;
